import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { get as getCookie } from "../../cookies/index";
import { Page } from '../../../../src/enums/page';
declare const window: any;

let shouldRedirectToHomePage = function () {
    var url = window.location.href;
    var currentPage = url.split('/').pop();
    if (currentPage) {
        if (currentPage.indexOf(Page.ORDERCONFIRMATION) > -1 || currentPage.indexOf(Page.CHECKOUTSHIPPING) <= -1) {
            return true;
        }
    }
    return false;
};

let getBaseUrl = function () {
    return window.locale_details.site_baseurl + '/?d=' + new Date().getTime();
};

let redirectToHomePage = function () {
    window.location.replace(window.locale_details.site_baseurl + '/?d=' + new Date().getTime());
    return;
}

let clearSession = function () {
    window.np.sessionCleanUp();
    window.reorder?.ls?.remove();
    window?.OneTrust?.AllowAll();
}

export function useSessionValidityCheck() {
    const checkSessionValidity = async () => {
        try {
            const activeSessionToken = getCookie("np.activeSessionToken");
            const authfront_access_token = getCookie("authfront_access_token");
            const authfront_refresh_token = getCookie("authfront_refresh_token");
            const {userId, isLoggedIn} = window.np.getUserInfo();

            // If old activeSessionToken is present clear the old session and redirect.
            if (activeSessionToken) {
                clearSession();
                redirectToHomePage();
                return;
            }

            if (isLoggedIn) { 
                // First Check for refresh token
                if(!authfront_refresh_token){
                    clearSession();
                    //If accesss token also not present, redirect user to home page, as logout will not work
                    if(!authfront_access_token) {
                        redirectToHomePage();
                        return;
                    }

                    //Logout & redirect
                    if (shouldRedirectToHomePage()) {
                        window.mcpAuth.logout(getBaseUrl());
                    } else {
                        window.mcpAuth.logout(window.location.href);
                    }
                }
                
                // Reload if userId or Access token is not present
                if(!userId || !authfront_access_token){
                    window.location.reload();
                    return;
                }
            }
        } catch (error) {
            console.error(error);
        }
    };
    return checkSessionValidity;
}
const SessionValidationWrapper: React.FC = ({ children }) => {
    const navigate = useNavigate();
    const checkSessionValidity = useSessionValidityCheck();
    useEffect(() => {
        checkSessionValidity();
    }, [navigate]);
    return <>{children}</>;
};
export default SessionValidationWrapper;
